export const rootNode = document.getElementById('prospect-treanding-apps-root');

export const initParams = () => ({
  defaultOsName: rootNode.dataset.defaultOsName,
  shareOptions: JSON.parse(rootNode.dataset.shareOptions),
  data: JSON.parse(rootNode.dataset.data),
  trendingUpReport: JSON.parse(rootNode.dataset.trendingUpReport),
  trendingDownReport: JSON.parse(rootNode.dataset.trendingDownReport),
  availableCategories: JSON.parse(rootNode.dataset.availableCategories),
});

export const parseUrlForFilters = () => {
  const { pathname, search } = window.location;
  const allFilters = pathname.match(
    /\/top-charts\/trending-apps\/(google-play|itunes-connect)\/([a-z-]+)?\/([a-z-]+)?/
  );
  const defaultFilters = pathname.match(/\/top-charts\/trending-apps/);
  const urlParams = new URLSearchParams(search);
  let filters = {};
  if (allFilters) {
    filters = { store: allFilters[1], category: allFilters[2], country: allFilters[3] };
  }

  if (!allFilters && defaultFilters) {
    filters = { store: defaultFilters[1] };
  }

  if (urlParams.get('date')) {
    filters = { ...filters, date: urlParams.get('date') };
  }

  return filters;
};
